import Vue from 'vue';

export default Vue.extend({
  name: 'C保存Button',

  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    click(): void {
      this.$emit('click');
    },
  },
});
